import * as React from "react";

export const ModuleHeader: React.FunctionComponent<{
  title: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}> = ({ title, style, children }) => (
  <header className="module-header" style={style}>
    <h1 dangerouslySetInnerHTML={{ __html: title }} />
    {children}
  </header>
);
